<template>
	<div class="footer">
		<div class="footer_main">
			<div class="address">
				<div class="name">上海助佳实业有限公司</div>
				<div class="text">电话：{{about.phone}}</div>
				<div class="text">邮箱：{{about.email}}</div>
			</div>
			<div class="content">
				<div class="about">
					<div class="text">关于我们</div>
					<div class="text">网站目录</div>
				</div>
				<div class="about">
					<router-link :to="{name:'about'}" class="link">公司介绍</router-link>
					<div  class="link">人事考试网</div>
				</div>
				<div class="about">
					<router-link :to="{name:'contact'}" class="link">联系我们</router-link>
					<div  class="link">军队人才网</div>
				</div>
				<div class="about">
					<div></div>
					<div  class="link">卫健变官网</div>
				</div>
				<div class="keep">Copyright© 沪ICP16025445号-1  上海助佳实业有限公司  版权所有<a
						href="https://beian.miit.gov.cn/">沪ICP16025445号-1</a></div>
			</div>
			<div class="code">
				<el-image src="./static/images/code.png" fit="fill"></el-image>
			</div>
		</div>
	</div>
</template>


<script>
	import mixins from '@/mixins/index'
	export default {
		mixins: [mixins],
		data() {
			return {
				about: ''
			}
		},
		mounted() {
			this.handindex()
		},
		methods: {
			handindex() {
				this.request({
					url: '/index/guanwang/contact_us',
					data: {},
					success: (res) => {
						if (res.code == 200) {
							this.about = res.data
						}
					}
				})
	
			}
		}
	}
</script>


<style lang="scss" scoped>
	.footer {
		width: 100%;
		height: 220px;
		background: #4D4D4D;
		display: flex;
		align-items: center;
		justify-content: center;

		.footer_main {
			max-width: 1200px;
			width: 100%;
			height: 220px;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.address {
				display: flex;
				flex-direction: column;
				height: 220px;

				.name {
					padding: 20px 0;
					font-size: 20px;
					color: #fff;
				}

				.text {
					color: #fff;
					font-size: 14px;
					padding: 10px 0;
				}
			}

			.content {
				height: 220px;
				display: flex;
				flex-direction: column;
				align-items: center;

				.about {
					width: 490px;
					padding: 0 20px;
					display: flex;
					align-items: center;
					justify-content: space-between;

					.text {
						color: #fff;
						font-size: 20px;
						padding: 20px 0;
					}

					.link {
						width: 80px;
						height: 34px;
						background: #404040;
						font-size: 14px;
						color: #fff;
						display: flex;
						align-items: center;
						justify-content: center;
						margin: 2px 0;

					}
				}

				.keep {
					margin-top: 15px;
					font-size: 12px;
					color: #B2B2B2;

					a {
						color: #B2B2B2;
					}
				}
			}

			.code {
				.el-image {
					width: 96px;
					height: 96px;
				}
			}

		}

		}
</style>



// WEBPACK FOOTER //
// src/components/common/Footer.vue